export default "__VITE_ASSET__BpQSy$7h__"